var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 48L464 152V360L256 464L48 360V152L256 48Z",
    stroke: "#7E8A7C",
    strokeWidth: 20,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 160C256 160 286 210 286 250C286 290 256 330 256 330C256 330 226 290 226 250C226 210 256 160 256 160Z",
    fill: "#7E8A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 250C256 250 306 250 336 290C366 330 346 370 346 370C346 370 306 380 266 350C226 320 256 250 256 250Z",
    fill: "#7E8A7C",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 250C256 250 206 250 176 290C146 330 166 370 166 370C166 370 206 380 246 350C286 320 256 250 256 250Z",
    fill: "#7E8A7C",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 250C256 250 286 300 286 340C286 380 256 420 256 420C256 420 226 380 226 340C226 300 256 250 256 250Z",
    fill: "#7E8A7C",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.24a47f8dd052844b7f04f7ff0f6058f9.svg";
export { ForwardRef as ReactComponent };